import { render, staticRenderFns } from "./PageVerifyProfile.vue?vue&type=template&id=050a02b5&"
import script from "./PageVerifyProfile.vue?vue&type=script&lang=js&"
export * from "./PageVerifyProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports